import { v4 as uuidv4 } from "uuid";

const createNewSection = label => ({
	designInfo: {
		customStencilId: "null",
		stencilId: "cloud-tab-panel",
		stencilSuperIds: [ "SubSlotPanel" ],
		bounds: {
			lowerRight: {
				x: 944,
				y: 993,
			},
			upperLeft: {
				x: 25,
				y: 25,
			},
		},
	},
	enabled: true,
	extraSettings: {
		serverValidationMethod: "GET",
		layoutDefinition: {
			rows: [],
		},

	},
	i18n: {
		// eslint-disable-next-line camelcase
		en_us: {
			label: label,
		},
	},
	id: uuidv4(),
	ignore: false,
	isRequired: false,
	label: label,
	labelAlign: "top",
	size: 12,
	type: "panel",
	visible: true,

});


const toTranslation = label => ({
	label,
	i18n: {
		// eslint-disable-next-line camelcase
		en_us: {
			label,
		},
	},
});

export const changeUpdatedTabsInConfig = (config, updatedTabsList) => {
	let configSections = config.extraSettings.sections;
	let newConfigSections = [];
	for (const item of updatedTabsList) {
		const foundSection = configSections.find(section => section.id === item.id);
		if (foundSection !== undefined) {
			newConfigSections.push({
				...foundSection,
				...toTranslation(item.text),
			});
		} else {
			newConfigSections.push(createNewSection(item.text));
		}
	}

	return {
		...config,
		extraSettings: {
			...config.extraSettings,
			sections: newConfigSections,
			tabsorder: newConfigSections.map(({ id }) => id),
		}
	};
};
